/*                                                   */
import { o_global, o_util } from "@gr-common/head/namespaces";
import { toggle } from "@gr-exports/head/toggle";

import { deprecated } from "@gr-common/head/logger";
import * as browser from "../browser/head.js";
import * as animation from "../animation/head.js";
import * as cookie from "../cookie/head.js";
import * as core from "../core/head.js";
import * as dom from "../dom/head.js";
import * as history from "../history/head.js";
import * as misc from "../misc/head.js";
import * as hardcore from "../hardcore/head.js";
import { getNewScrollPosition } from "../animation/utils.js";
import { ajaxLegacy } from "./ajax/ajax.legacy.js";

if (toggle.get("gr_enable_legacy_helper", true)) {
  const { event } = o_util;

  const helper: Record<string, any> = {};

  /*                        */
  helper.isPlainObject = core.isPlainObject;
  helper.isEmptyObject = core.isEmptyObject;
  helper.cloneFunction = (core as any).cloneFunction;

  /*                          */
  helper.cookieExist = cookie.exists;
  helper.getCookie = cookie.get;
  helper.getCookieValue = cookie.get;
  helper.removeCookie = cookie.remove;
  helper.setCookie = cookie.set;

  /*                         */
  helper.delegate = event.delegate;
  helper.stopEvent = event.stop;
  helper.whichTransitionEvent = event.whichTransitionEndEvent;
  helper.addEvent = (event as any).add;
  helper.getEventTarget = (event as any).getTarget;
  helper.preventDefault = (event as any).preventDefault;
  helper.removeEvent = (event as any).remove;
  helper.stopPropagation = (event as any).stopPropagation;

  /*                       */
  helper.hasClassInParents = dom.hasClassInParents;
  helper.getParentByClassName = dom.getParentByClassName;
  helper.stringToDocumentFragment = dom.stringToDocumentFragment;
  helper.hasClass = (dom as any).hasClass;
  helper.removeClass = (dom as any).removeClass;
  helper.toggleClass = (dom as any).toggleClass;
  helper.getElementsByClassname = (dom as any).getElementsByClassname;
  helper.addClass = (dom as any).addClass;

  /*                             */
  helper.Easings = animation.easings;
  helper.requestAnimFrame = requestAnimationFrame;
  helper._getNewScrollPosition = getNewScrollPosition;
  helper.scrollTo = animation.scrollTo;

  /*                        */
  helper.ajax = ajaxLegacy;

  /*                           */
  helper.getScrollbarWidth = browser.getScrollbarWidth;
  helper.getStyle = browser.getStyle;

  /*                           */
  helper.setScrollRestoration = history.setScrollRestoration;
  helper.resetScrollRestoration = history.resetScrollRestoration;

  /*                        */
  helper.isResponsive = misc.isResponsive;
  helper.isValidMouseButton = misc.isValidMouseButton;
  helper.setVendorStyle = misc.setVendorStyle;

  /*                            */
  helper.evalScript = hardcore.evalScript;
  helper.executeInlineScripts = hardcore.executeInlineScripts;

  /*                        */
  (
    [
      ["helper", helper],
      ["referrer", document.referrer], /*                     */
      ["getCookieValue", cookie.get],
      ["isResponsive", misc.isResponsive],
    ] as const
  ).forEach(([key, value]) => {
    const desc: PropertyDescriptor = {
      configurable: true,
      enumerable: true,
      get: deprecated(() => value, "deprecated", key, "legacy helper, do not use!"),
    };
    Object.defineProperty(o_global, key, desc);
  });
}
